const messages = {
  message: {
    name: 'Nom',
    surName: 'Prénom',
    mobile: 'Téléphone portable',
    email: 'Email',
    company: 'Raison Sociale',
    cif: 'SIRET',
    profile: 'Profil de l\'entreprise',
    phone: 'Téléphone',
    country: 'Pays',
    location: 'Département',
    address: 'Adresse',
    city: 'Ville',
    cp: 'Code Postal',
    web: 'Site internet',
    comment: 'Observations',
    terms: {
      wp: 'J\'ai lu et j\'accepte la <a href="/politica-privacidad"> politique de confidentialité</a> et les <a href="http://myzone.airzone.es/condiciones-uso">conditions d\'utilisation</a>.',
      myzone: 'J\'ai lu et j\'accepte la <a href="/politica-privacidad"> politique de confidentialité</a> et les <a href="/condiciones-uso">conditions d\'utilisation</a>.',
    },
    infoComercial: 'Je souhaite recevoir des informations sur les actualités Airzone,.',
    formsError: {
      terms: 'Vous devez accepter les conditions d\'utilisation et la politique de confidentialité.',
      front: 'Impossible d\'envoyer le formulaire en raison des erreurs suivantes',
      server: 'Votre message n\'a pas pu être envoyé. S\'il vous plait, réessayez plus tard.',
    },
    formsSuccess: {
      AirzoneSIM: 'Vous vous êtes inscrit correctement, vous allez bientôt recevoir un email avec l\'outil.',
      Myzone: 'Votre demande a été enregistrée, elle sera traitée dans les meilleurs délais.',
    },
    personalData: 'Vos données personnelles',
    companyData: 'Les données de votre entreprise',
    submit: 'Envoyer',
    selectSim: {
      label: '¿Como conoció Airzone SIM?',
      options: {
        'Técnico/Comercial/Prescriptor': 'Técnico / Comercial / Prescriptor',
        'Distribuidor/Oficial/ATD': 'Distribuidor / Oficial / ATD',
        'Promotora/Constructora': 'Promotora / Constructora',
        'Arquitecto/Ingeniería': 'Arquitecto / Ingeniería',
        Instalador: 'Instalador',
        'RRSS/Medios': 'Redes sociales / Medios',
        'Cursos-Formacion': 'Cursos de Formación',
      },
    },
  },
};

export default messages;
